import Operator from './operator';
var and;
and = function () {
    var filters = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        filters[_i] = arguments[_i];
    }
    return {
        operator: Operator.and,
        filters: filters,
    };
};
export default and;
